<div *ngIf="phoneApp">
  <div class="daPic">
    <div style="text-align: center">
      <div class="titleFont" style="padding-top: 40%; color:white;font-size: 30px; padding-left: 0">Detention Claim Inquiry </div>

    </div>

    <table style="width: 100%; height: 100%; padding-top: 1%; margin: 0px">
      <tr>
        <td  >
          <table  class="table-fill" style="height: 100%; text-align: center">
            <tr>
              <td style="vertical-align: top;">
                <div>
                  <mat-card class="speech-bubble3" style="text-align: center;background-color: rgba(238,238,237,1); " xmlns="http://www.w3.org/1999/html">
                    <div style="padding-top: 20px">
                      <mat-form-field class="newField myOption" style=" font-size: 17px; min-width: 95%; max-width: 95%; background-color: transparent" appearance="outline" >
                        <mat-label style="color: #E61E00;">Search Criteria</mat-label>
                        <mat-select  [(value)]="savedList" (selectionChange)="wipeOutScreen()"   >
                          <mat-option class="myOption" *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>


                    <mat-form-field class="newField" style=" font-size: 17px; min-width: 95%; max-width: 95%;" appearance="outline" >
                      <input  [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()">
                      <mat-icon (click)="getSearchItems()" matSuffix><img style="vertical-align: center;" src="assets/search.svg" ></mat-icon>
                    </mat-form-field>

                    <div class="errorDiv2" style="text-align: center" *ngIf="submitted && maherError!=null">{{maherError}}</div>

                    <div class="errorDiv2" style="text-align: center;  padding-bottom: 10px" *ngIf="submitted && didntEnterShit">Please Enter A Value</div>
                    <div class="errorDiv2" style="text-align: center;  padding-bottom: 10px" *ngIf="submitted && notANumber">Visit/Claim Must Be Numeric</div>
                    <div class="errorDiv2" style="text-align: center;  padding-bottom: 10px" *ngIf="submitted && badChars">Invalid Character in {{containerNum}}</div>

                  </mat-card>
                </div>

                <div *ngIf="showDetailScreen">


                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="detention2"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">General Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Claim Number</mat-label>
                        <input  [(ngModel)]="detDetail.detention_claim_id" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Claim Amount</mat-label>
                        <input [(ngModel)]="detDetail.claim_amountFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Claim Date</mat-label>
                        <input [(ngModel)]="detDetail.claim_date_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Claim By</mat-label>
                        <input [(ngModel)]="detDetail.claim_by" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Visit Number</mat-label>
                        <input [(ngModel)]="detDetail.visit" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Visit Dates</mat-label>
                        <input [(ngModel)]="detDetail.visit_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Claim Notes</mat-label>
                        <input [(ngModel)]="detDetail.claim_remarks" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">

                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="payment"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Payment Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Status</mat-label>
                        <input  [(ngModel)]="detDetail.status_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Authorized Amount</mat-label>
                        <input [(ngModel)]="detDetail.authorized_amountFmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Processed</mat-label>
                        <input [(ngModel)]="detDetail.authorized_date_fmt" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Check Number</mat-label>
                        <input [(ngModel)]="detDetail.payment_number" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Check Date</mat-label>
                        <input [(ngModel)]="detDetail.payment_date" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                  <div style="padding-top: 8%" *ngIf="detDetail.rejected_date!=' '">
                    <mat-card class="iso-bubble" style="text-align: center;background-color: rgba(238,238,237,0.7);" xmlns="http://www.w3.org/1999/html">
                      <div style="text-align: -webkit-center; text-align: -moz-center;height: 35px">
                        <div class="cancelled"></div>
                      </div>
                      <div style="text-align: -webkit-center">
                        <div class="lowerCaseLetters" style=" font-size: 14px; padding-bottom: 5px">Rejection Information</div>
                      </div>

                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Rejection Reason</mat-label>
                        <input  [(ngModel)]="detDetail.rejection_description" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Rejection Date</mat-label>
                        <input [(ngModel)]="detDetail.rejected_date" matInput readonly/>
                      </mat-form-field>
                      <mat-form-field class="newField" appearance="outline"  style="min-width: 95%">
                        <mat-label style="font-size: 20px; color: #E61E00">Data Reseach Remarks</mat-label>
                        <input [(ngModel)]="detDetail.data_research_remarks" matInput readonly/>
                      </mat-form-field>
                    </mat-card>
                  </div>

                </div>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</div>



<div class="centered">
<mat-card class="speech-bubble-not-allowed" *ngIf="dontAllowIn">
  <div class="maher3" (click)="myApp.showCharts()"></div>
  <div class="titleFont"  style="padding-bottom: 10px; text-align: center; ">Detention Claims</div>
  <div class="lowerCaseLetters" style="font-size: 19px; text-align: center">
      In order to use this option you must contact Alta Vigier,
    <a href="mailto:avigier@maherterminals.com"> avigier&#64;maherterminals.com </a>, to create a vendor profile. <br/>Please ensure to provide your <b>company complete name, address and SCAC code</b> in your e-mail.
  </div>
  <div style="text-align: center; padding-top: 4%; padding-bottom: 1%" >
    <button mat-raised-button (click)="myApp.showCharts()"  class="blueButton" >Close</button>
  </div>
</mat-card>
</div>


<table class="mainTable" style="width: 100%">
  <tr>
    <td class="mainUpperTd">

      <mat-card class="insView" *ngIf="showInsertScreen">
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 18%">
              <div class="maher" (click)="myApp.showCharts()"></div>
            </td>
            <td style="width: 70%">
              <div >
                <mat-form-field class="search"  appearance="outline">
                  <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
                  <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/clock.png" ></mat-icon>
                  <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                </mat-form-field>
              </div>
              <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 25%">Please Enter Claim Amount and Remarks (optional)</div>
            </td>
            <td style="width: 20%" *ngIf="ipadApp">
              <div >
                <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch2()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
              </div>
            </td>
          </tr>
        </table>
        <form  [formGroup]="myForm2" autocomplete="off"   novalidate>
          <div class="flex-item2" >

            <mat-table #table23 style="width:100%" [dataSource]="insertData" multiTemplateDataRows matSort="container"  >
              <ng-container matColumnDef="detention_claim_id" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Claim</mat-header-cell>
                <mat-cell style="color: #E61E00" *matCellDef="let row">{{row.detention_claim_id}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="visit" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Visit</mat-header-cell>
                <mat-cell *matCellDef="let row" >{{row.visit}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="claim_amount" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{claimCol}}</mat-header-cell>
                <mat-cell   *matCellDef="let row">
                  <div *ngIf="(!insertSubmitted && row.maherError==null)">
                    <mat-form-field style="min-width: 50%; max-width: 50%; max-height: max-content; "  appearance="outline"  >
                      <input  matInput [(ngModel)]="row.claim_amount"  formControlName="amount" style="vertical-align: super" >
                    </mat-form-field>
                  </div>
                  <div *ngIf="(insertSubmitted)">
                    {{row.claim_amount}}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="claim_remarks" >
                <mat-header-cell  *matHeaderCellDef mat-sort-header  class="myHeader">Claim Remarks</mat-header-cell>
                <mat-cell  *matCellDef="let row">
                  <div *ngIf="(!insertSubmitted && row.maherError==null)" style="min-width: 100%; max-width: 100%">
                    <mat-form-field style="min-width: 100%; max-width: 100%; padding: 0.1em 0.1px;"  appearance="outline" >
                      <input  matInput [(ngModel)]="row.claim_remarks" formControlName="remarks" style="vertical-align: super" maxlength="30" >
                    </mat-form-field>
                  </div>
                  <div *ngIf="(insertSubmitted)">
                    {{row.claim_remarks}}
                  </div>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="claim_date" >
                <mat-header-cell   *matHeaderCellDef mat-sort-header  class="myHeader">Submitted Date</mat-header-cell>
                <mat-cell  *matCellDef="let row">{{row.claim_date}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="claim_by" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Submitted By</mat-header-cell>
                <mat-cell  *matCellDef="let row">{{row.claim_by}}</mat-cell>
              </ng-container>
              <ng-container matColumnDef="maherError" >
                <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Error Message</mat-header-cell>
                <mat-cell *matCellDef="let row" >{{row.maherError}}</mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="insColumns; sticky: true"></mat-header-row>
              <mat-row   *matRowDef="let row; columns: insColumns;" class="table-row"></mat-row>
            </mat-table>
            <mat-toolbar style="width: 100%; display: unset" *ngIf="insertSubmitted && insertError">
              <mat-toolbar-row style="width: 100%; height: 30px; justify-content: center ">
                <div class="errorDiv2" style="text-align: center" >Claim Amount(s) are not formatted correctly or left blank</div>

              </mat-toolbar-row>
            </mat-toolbar>
            <mat-toolbar style="width: 100%; display: unset">
              <mat-toolbar-row style="width: 100%; ">
                <button mat-raised-button *ngIf="foundAGoodOne" (click)="submitClaims()"  class="blueButton" >Submit</button>

                <mat-paginator class="myPaginator"  [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>

              </mat-toolbar-row>
            </mat-toolbar>
          </div>
        </form>

      </mat-card>


      <mat-card class="quickView" *ngIf="showQuickView">
        <table style="width: 100%; border-collapse: collapse;margin: 0px; padding: 0px">
          <tr>
            <td style="width: 18%">
              <div class="maher" (click)="myApp.showCharts()"></div>
            </td>
            <td style="width: 70%">
              <div >
                <mat-form-field class="search"  appearance="outline">
                  <mat-label style="padding-left: 20px;">Search by Any Available Columns</mat-label>
                  <mat-icon matPrefix ><img style="vertical-align: center;height:25px; width: 25px" src="assets/clock.png" ></mat-icon>
                  <input  maxlength="30" style="padding-left: 20px;"  matInput (keyup)="applyFilter($event.target.value)"  [formControl]="search1">
                </mat-form-field>
              </div>
              <div class="lowerCaseLetters" style="font-size: 14px; padding-left: 25%">Click On Any Row To View Details For Claims</div>
            </td>
            <td style="width: 20%" *ngIf="ipadApp">
              <div >
                <div class="lowerCaseLetters" *ngIf="this.ipadApp" (click)="returnToSearch2()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
              </div>
            </td>
          </tr>
        </table>

        <div class="flex-item2" >
          <mat-table #table23 style="width:100%" [dataSource]="quickViewData" multiTemplateDataRows matSort="container"  >
            <ng-container matColumnDef="detention_claim_id" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Claim</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.detention_claim_id}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="visit" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Visit</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.visit}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="claim_amount" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{claimCol}}</mat-header-cell>
              <mat-cell *matCellDef="let row" >{{row.claim_amount}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="claim_date" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">{{claimDateCol}}</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.claim_date}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="status_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Status</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.status_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="ap_transfered_date">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 5px"  class="myHeader">Transferred</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.ap_transfered_date}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="authorized_amount" >
              <mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 5px" class="myHeader">Authorized</mat-header-cell>
              <mat-cell  *matCellDef="let row">{{row.authorized_amount}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="rejection_description" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Rejection Reason</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.rejection_description}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="claim_remarks" >
              <mat-header-cell *matHeaderCellDef mat-sort-header  class="myHeader">Notes</mat-header-cell>
              <mat-cell *matCellDef="let row">{{row.claim_remarks}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="qvColumns; sticky: true"></mat-header-row>
            <mat-row   *matRowDef="let row; columns: qvColumns;" class="table-row" (click)="showDetails(row)"></mat-row>
          </mat-table>
          <mat-toolbar style="width: 100%; display: unset">
            <mat-toolbar-row style="width: 100%; ">
              <mat-paginator class="myPaginator" (touchstart)="dontShowSearch()" [pageSize]="20" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
              <span style="padding-left: 34%">
                  <button mat-raised-button matTooltip="Export To Excel"  (click)="exportExcel()"><img style="height: 38px"  src="assets/excel.png" ></button>
              </span>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
      </mat-card>




      <mat-card class="details" *ngIf="showDetailScreen">
        <table style="width: 100%; height: 100%">
          <tr>
            <td style="width: 90%;">


              <mat-card class="contDetails">
                <table style="width: 100%">
                  <tr>
                    <td style="width: 2%">
                      <div class="maher2" (click)="myApp.showCharts()"></div>
                    </td>
                    <td style="width: 17%">
                      <div class="titleFont" style="font-size: 23px; padding-left: 0;">Detention Details</div>
                    </td>
                    <td style="width: 14%">
                      <div class="titleFont" style="padding-left: 0%; font-size: 23px">Visit:<a style="color: green"> {{detDetail.visit}}</a></div>
                    </td>
                    <td style="width: 32%">
                      <div class="titleFont" style="padding-left: 0%; font-size: 23px">Status:
                        <a *ngIf="detDetail.status!='R'" style="color: green"> {{detDetail.status_description}}</a>
                        <a *ngIf="detDetail.status=='R'" style="color: #E61E00"> {{detDetail.status_description}}</a>
                      </div>
                    </td>
                    <td style="width: 15%">
                      <div class="lowerCaseLetters" [hidden]="detDetails.length==1" (click)="returnToQuickView()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Quick View</div>
                      <div class="lowerCaseLetters" *ngIf="detDetails.length==1 && ipadApp" (click)="returnToSearch()" style="font-size: 14px; color: #E61E00; cursor: pointer">Back To Search</div>
                    </td>
                  </tr>
                </table>



                <table style="width: 100%; height: 100%; padding: 0px; margin: 0px">
                  <tr>
                    <td style="width: 85%; height: 100%; text-align: center;" >
                      <table  class="table-fill" style="height: 100%">
                        <tr>
                          <td style="vertical-align: top; height: 100%">
                            <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%">
                              <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Detention Claim Info</div>

                              <div>
                                <mat-form-field appearance="outline"  >
                                  <mat-label style="font-size: 18px; color: #E61E00">Claim Number</mat-label>
                                  <input [(ngModel)]="detDetail.detention_claim_id" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline"  >
                                  <mat-label style="font-size: 18px; color: #E61E00">Claim Amount</mat-label>
                                  <input [(ngModel)]="detDetail.claim_amountFmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline"  >
                                  <mat-label style="font-size: 18px; color: #E61E00">Claim Date</mat-label>
                                  <input [(ngModel)]="detDetail.claim_date_fmt" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline"  >
                                  <mat-label style="font-size: 18px; color: #E61E00">Claim By</mat-label>
                                  <input [(ngModel)]="detDetail.claim_by_description" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Visit</mat-label>
                                  <input [(ngModel)]="detDetail.visit" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Visit Date</mat-label>
                                  <input [(ngModel)]="detDetail.visit_date" matInput readonly/>
                                </mat-form-field>
                              </div>
                              <div>
                                <mat-form-field appearance="outline" >
                                  <mat-label style="font-size: 18px; color: #E61E00">Claim Notes</mat-label>
                                  <textarea style="max-height: 40px; min-height: 40px" [(ngModel)]="detDetail.claim_remarks" matInput readonly></textarea>
                                </mat-form-field>
                              </div>
                            </div>
                          </td>


                          <td style="vertical-align: top; height: 100%" >
                            <div style="background-color: rgba(23,122,241,0.07); border: #E61E00 1px solid; height: 100%">

                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Payment Info</div>

                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline">
                                    <mat-label style="font-size: 18px; color: #E61E00">Status</mat-label>
                                    <input [(ngModel)]="detDetail.status_description"  matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Authorized Amount</mat-label>
                                    <input [(ngModel)]="detDetail.authorized_amountFmt" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Processed</mat-label>
                                    <input [(ngModel)]="detDetail.authorized_date_fmt" matInput readonly/>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </td>

                          <td style="vertical-align: top; height: 100%" *ngIf="detDetail.rejected_date!=' '" >
                            <div style="background-color: rgba(238,238,237,0.7); border: #E61E00 1px solid; height: 100%">

                              <div >
                                <div class="lowerCaseLetters" style="font-size: 13px; text-align: left; padding-left: 5%;padding-bottom: 15px ">Rejection Info</div>

                                <div style="padding-top: 2px">
                                  <mat-form-field appearance="outline" style="min-width: 95%">
                                    <mat-label style="font-size: 18px; color: #E61E00">Rejection Reason</mat-label>
                                    <textarea style="max-height: 60px; min-height: 60px" [(ngModel)]="detDetail.rejection_description" matInput readonly></textarea>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" style="min-width: 95%">
                                    <mat-label style="font-size: 18px; color: #E61E00">Rejection Date</mat-label>
                                    <input [(ngModel)]="detDetail.rejected_date" matInput readonly/>
                                  </mat-form-field>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" style="min-width: 95%" >
                                    <mat-label style="font-size: 18px; color: #E61E00">Data Research Remarks</mat-label>
                                    <textarea style="max-height: 60px; min-height: 60px" [(ngModel)]="detDetail.data_research_remarks" matInput readonly></textarea>
                                  </mat-form-field>
                                </div>
                              </div>
                            </div>
                          </td>

                        </tr>
                        <tr>
                          <td style="width: 100%" colspan="3">
                            <table style="width: 100%">
                              <tr>
                                <td style="width: 80%">
                                </td>
                                <td style="width: 10%" >
                                  <div class="lowerCaseLetters" [hidden]="detDetails.length==1" (click)="previousTransaction()" style="font-size: 14px; color: #E61E00; cursor: pointer">Previous Record</div>
                                </td>
                                <td style="width: 10%" >
                                  <div class="lowerCaseLetters" [hidden]="detDetails.length==1" (click)="nextTransaction()" style="font-size: 14px; color: #E61E00; cursor: pointer">Next Record</div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </mat-card>
            </td>
            <td class="loginPic" style="">

            </td>
          </tr>
        </table>
      </mat-card>

    </td>
    <td class="mainLowerTd">
      <mat-card class="speech-bubble" *ngIf="allowIn" id="noPrint">
        <div class="detention" style="margin-top: 2%;"></div>
        <div class="titleFont" *ngIf="!inquiryOnly" style="padding-bottom: 10px; text-align: center">Detention Claims</div>
        <div class="titleFont" *ngIf="inquiryOnly" style="padding-bottom: 10px; text-align: center; font-size: 24px">Detention Claims Inquiry</div>


        <mat-toolbar *ngIf="!inquiryOnly" style="background-color: white; padding-top: 2%; padding-bottom: 3%">
          <mat-toolbar-row style="padding-left: 30%; height: 20px;">
            <div class="onoffswitch">
              <input type="checkbox" (click)="setCheckedField()"  class="onoffswitch-checkbox" id="myonoffswitch" >
              <label class="onoffswitch-label" for="myonoffswitch">
                <div class="onoffswitch-inner"></div>
                <div class="onoffswitch-switch"></div>
              </label>
            </div>
          </mat-toolbar-row>
        </mat-toolbar>

        <mat-form-field class="myOption2"  appearance="outline" *ngIf="!showInsert">
          <mat-select  [(value)]="savedList" (selectionChange)="wipeOutScreen()" >
            <mat-option  *ngFor="let lr of savedLists" [value]="lr.code">{{lr.description}}</mat-option>
          </mat-select>
        </mat-form-field>




        <div class="flex-item3" *ngIf="savedList=='VISIT' || savedList=='CLAIMNUMBER' || showInsert">
          <div *ngIf="savedList!='CLAIMNUMBER'" class="lowerCaseLetters" style="font-size: 14px; text-align: center">Enter Up To 100 Visits</div>
          <div *ngIf="savedList=='CLAIMNUMBER'" class="lowerCaseLetters" style="font-size: 14px; text-align: center">Enter Up To 100 Claim Numbers</div>
          <mat-form-field  class="newField" appearance="outline" >
            <mat-label>Search Value</mat-label>
            <textarea class="textarea" [(ngModel)]="txtFromArea"  matInput cdkTextareaAutosize oninput="this.value = this.value.toUpperCase()"></textarea>
          </mat-form-field>
          <div class="errorDiv2" style="text-align: center" *ngIf="submitted && didntEnterShit">Please Enter A Value</div>
        </div>

        <div *ngIf="(savedList=='CLAIMSTATUS' || savedList=='CLAIMSTATUSDATE') && !showInsert">
          <mat-form-field class="myOption2"  appearance="outline">
            <mat-label>By Status</mat-label>
            <mat-select #mySel [(value)]="statusChosen2" (selectionChange)="wipeOutScreen()" multiple>
              <mat-option value="ALL" (click)="toggleAllSelection()" >All</mat-option>
              <mat-option (click)="toggleOtherOptions()" *ngFor="let lr of listStatus" [value]="lr.code">{{lr.description}}</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="errorDiv2" style="text-align: center" *ngIf="submitted && didntEnterShit">Must Choose A Status</div>
        </div>


        <div *ngIf="savedList=='CLAIMSTATUSDATE' && !showInsert">




            <mat-form-field style="min-width: 95%;  color: #005999; font-weight: bolder" appearance="outline">
              <mat-label>Claim Date</mat-label>

              <mat-date-range-input [rangePicker]="picker"  [dateFilter]="dateFilter"  style="width: 100%; position:relative; top: 6px; color: black; font-weight: 600; font-size: 17px" >
                <input matStartDate matInput style="margin-top: 0"  [(ngModel)]="start_date_in"  (dateChange)="emitDates($event)">
                <input matEndDate   matInput [(ngModel)]="end_date_in" (dateChange)="emitDates($event)">
              </mat-date-range-input>
              <mat-date-range-picker #picker  ></mat-date-range-picker>
              <mat-datepicker-toggle  style="font-size: 16px; position: relative; top: -8px;"  matSuffix [for]="picker"></mat-datepicker-toggle>
            </mat-form-field>
          <div class="errorDiv2" style="text-align: center" *ngIf="submitted && didntEnterShit">Must Choose A Date</div>

        </div>
        <div class="errorDiv2" style="text-align: center" *ngIf=" maherError!=null">{{maherError}}</div>
        <div class="errorDiv2" style="text-align: center;  padding-bottom: 10px" *ngIf="didntEnterShit">Please Enter A Value</div>
        <div class="errorDiv2" style="text-align: center;  padding-bottom: 10px" *ngIf=" notANumber">Visit/Claim Must Be Numeric</div>
        <div class="errorDiv2" style="text-align: center;  padding-bottom: 10px" *ngIf="badChars">Invalid Character in {{containerNum}}</div>


        <mat-toolbar mat-toolbar class="toolbar2" >
          <mat-toolbar-row style="width: 95%; justify-content: center">
            <span style="padding-left: 20px"></span>
            <div style="text-align: center; padding-top: 5%; padding-bottom: 5%" *ngIf="!showInsert">
              <button mat-raised-button (click)="getSearchItems()"  class="blueButton" >Search</button>
            </div>
            <div style="text-align: center; padding-top: 5%; padding-bottom: 5%" *ngIf="showInsert">
              <button mat-raised-button (click)="getVisitsForInsert()"  class="blueButton" >Search</button>
            </div>
            <span class="example-fill-remaining-space3" *ngIf="savedList=='VISIT' || savedList=='CLAIMNUMBER' || showInsert"></span>
            <button mat-raised-button  *ngIf="savedList=='VISIT' || savedList=='CLAIMNUMBER' || showInsert" class="redButton" (click)="wipeOutSearch()" >Clear List</button>
          </mat-toolbar-row>

        </mat-toolbar>


        <div *ngIf="savedList=='VISIT' || savedList=='CLAIMNUMBER'">
          <mat-form-field class="myOption2"  appearance="outline">
            <mat-label>Saved Lists</mat-label>
            <mat-select  [(value)]="savedList2" >
              <mat-option  *ngFor="let lr of savedLists2" [value]="lr.id">{{lr.description}}</mat-option>
            </mat-select>
          </mat-form-field>


          <mat-toolbar class="myToolbar" >
            <mat-toolbar-row style="padding-left: 14%; height: 35px" >
              <button mat-button matTooltip="retrieve your saved list" (click)="showContainersFromList()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/saved_search-24px.svg" ></button>
              <button mat-button matTooltip="update your saved list" (click)="updateContainerList('U')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>
              <button mat-button matTooltip="delete your saved list" (click)="deleteHit()" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/delete-24px.svg" ></button>
            </mat-toolbar-row>
          </mat-toolbar>
          <mat-toolbar class="myToolbar" style="background-color: white">
            <mat-toolbar-row  >
              <mat-form-field  appearance="outline" style="min-width: 76%; max-width: 76%" >
                <mat-label>New List</mat-label>
                <input maxlength="15" [(ngModel)]="myNewListName"  oninput="this.value = this.value.toUpperCase()" matInput/>
              </mat-form-field>
              <button mat-button matTooltip="create a new saved list" (click)="updateContainerList('I')" class="upperFonts" style="color:black;  font-size: 18px "><img  src="assets/save-24px.svg" ></button>

            </mat-toolbar-row>
            <mat-toolbar-row style="height: 26px; justify-content: center">
              <div class="errorDiv2" style="text-align: center" *ngIf=" insertListExists">List Exists For This User</div>
              <div class="errorDiv2" style="text-align: center" *ngIf=" insertNoConts ">List Needs At Least 1 {{stringOut}}</div>
              <div class="errorDiv2" style="text-align: center" *ngIf=" noListName ">List Name Cannot Be Blank</div>
            </mat-toolbar-row>
          </mat-toolbar>
        </div>
      </mat-card>

    </td>
  </tr>
</table>







